import { mapState } from 'vuex';

export default {
  name: 'getHoursDifferenceMixin',

  computed: {
    ...mapState({
      medicalOrders: ({ currentAdmission }) => currentAdmission.data.medicalOrders,
    }),

    examDate() {
      if (this.medicalOrders && !!this.medicalOrders.length && this.medicalOrders[0].exams) {
        const exams = this.medicalOrders[0].exams;
        const exam = exams[0] ? exams[0] : {};
        const examDate = exam.schedulingDate ? exam.schedulingDate : null;
        return examDate;
      }

      return null;
    }
  },

  methods: {
    returnExamsDates() {
      if (this.medicalOrders && !!this.medicalOrders.length && this.medicalOrders[0].exams && !!this.medicalOrders[0].exams.length) {
        let dates = [];
        dates = this.medicalOrders[0].exams.map(exam => {
          return exam.schedulingDate ? new Date(exam.schedulingDate).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR');
        });

        if (dates.length) return [...new Set(dates)];
      }

      return undefined;
    },
    returnAdmissionHour() {
      if (this.examDate) {
        return this.$moment(this.examDate).format('HH:mm');
      }

      return this.$moment(new Date()).format('HH:mm');
    },
    returnHour(isoTimestamp = null) {
      if (isoTimestamp) {
        return this.$moment(isoTimestamp).format('HH:mm');
      }

      return undefined;
    },
    isEqualDates(firstDate, secondDate) {
      return firstDate.getDate() === secondDate.getDate() &&
        firstDate.getMonth() === secondDate.getMonth() &&
        firstDate.getFullYear() === secondDate.getFullYear();
    },

    returnHoursDifference(firstDate, futureDate) {
      const isEqual = this.isEqualDates(new Date(firstDate), new Date(futureDate));
      const todayHours = new Date(firstDate).getHours();
      const futureHours = new Date(futureDate).getHours();

      if (isEqual && todayHours > futureHours) {
        return 0;
      }
      const diff = (new Date(futureDate).getTime() - new Date(firstDate)) / 1000;
      const finalHours = diff / (60 * 60);

      return finalHours;
    },
  }
};
